import { render, staticRenderFns } from "./Pagination2.vue?vue&type=template&id=6743d16e&scoped=true&"
import script from "./Pagination2.vue?vue&type=script&lang=js&"
export * from "./Pagination2.vue?vue&type=script&lang=js&"
import style0 from "./Pagination2.vue?vue&type=style&index=0&id=6743d16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6743d16e",
  null
  
)

export default component.exports